import { PORTAL_LANDING_ROUTE } from "@/lib/portal/portal-routes";

/** Destination for the ABC brand logo: the shared Developer Platform landing. */
export function useBrandHomeRoute(): string {
  return PORTAL_LANDING_ROUTE;
}
